import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation exchangeOTP($email: String!, $code: String!) {
    exchangeOTP(email: $email, code: $code)
  }
`;

export type Variables = {
  readonly email: string;
  readonly code: string;
};

export type Response = {
  readonly exchangeOTP: string;
};

export const useExchangeOTPMutation = (
  options: MutationHookOptions<Response, Variables>,
) => useMutation<Response, Variables>(MUTATION, options);
